import { MiddlewareAction } from "../middleware";
import { UnderwritingUiEmbedPage } from "../models/underwritingUi";

export enum UnderwritingUiActions {
  REQUEST_GET_EMBED_URL = "REQUEST_GET_EMBED_URL",
}

export interface GetUnderwritingUiEmbedUrlRequest {
  page: UnderwritingUiEmbedPage;
  policyName?: string;
  basePolicyName?: string;
  targetPolicyName?: string;
  executionId?: string;
}

export interface GetUnderwritingUiEmbedUrlResponse {
  url: string;
  expiresAt: string;
}

export function getUnderwritingUiEmbedUrl(
  payload: GetUnderwritingUiEmbedUrlRequest
): MiddlewareAction {
  return {
    actionName: UnderwritingUiActions.REQUEST_GET_EMBED_URL,
    type: "POST",
    url: "/v1/underwriting/ui/embed-url",
    body: payload,
  };
}
